<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<ng-container *ngIf="organizationHierarchy; else loading">
	<div class="copo-organization-flow-chart-container">
		<ol class="copo-organization-flow-chart-container-chart">
			<li class="copo-organization-flow-chart-container-chart-wrapper">
				<ng-container *ngFor="let supplier of organizationHierarchy?.suppliers">
					<div class="copo-organization-flow-chart-container-supplier">
						<div class="copo-organization-flow-chart-container-supplier-name">
							{{supplier.name}}
						</div>
					</div>
				</ng-container>
				<copo-organization-flow-chart-element [organization]="organizationFLowChart"
					[parent]="organizationHierarchy.parent" [currentId]="organizationId"
				></copo-organization-flow-chart-element>
			</li>
		</ol>
	</div>
</ng-container>
